/**
 * Cause d'un échec de `deleteScormModule` (API `module-in-use.exception.ts`) :
 * un module encore utilisé par des parcours est refusé (#178), et l'admin doit
 * savoir lesquels modifier.
 */
export type ModuleDeleteError
  = | { kind: 'inUse', sessions: string[] }
    | { kind: 'unknown' }

/**
 * Seul le message de l'erreur arrive au web : l'API y écrit les noms des
 * parcours entre « », on les relit là. Sans noms, le refus reste reconnu par
 * son code.
 */
export function moduleDeleteError(error: unknown): ModuleDeleteError {
  const message = error instanceof Error ? error.message : ''
  if (!message.includes('MODULE_IN_USE')) return { kind: 'unknown' }
  const sessions = [...message.matchAll(/« (.+?) »/g)].map(match => match[1]!)
  return { kind: 'inUse', sessions }
}
